import { render, staticRenderFns } from "./RakamlarIslem.vue?vue&type=template&id=2c1f0731&scoped=true&"
import script from "./RakamlarIslem.vue?vue&type=script&lang=js&"
export * from "./RakamlarIslem.vue?vue&type=script&lang=js&"
import style0 from "./RakamlarIslem.vue?vue&type=style&index=0&id=2c1f0731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f0731",
  null
  
)

export default component.exports